<script lang="ts">
	// Stores
	import { get } from 'svelte/store';
	import { user_data, user_settings } from 'src/stores/account/user';
import { alarms } from 'src/stores/lists/scenes-derived';
	// Services
	import { format } from 'svelte-i18n';
	// Components
	import SelectList from '../../../../../../SelectList/SelectList.svelte';
	// Types
	import type { ListType } from '../../../../../../SelectList/SelectList.types';
	import { is_automation_condition_ui } from 'src/types/AutomationConditionUI';
	import { is_device_trigger_ui, is_device_cond_ui } from 'src/types/DeviceCondAndTriggerUI';
	import { is_energy_exchange_ui } from 'src/types/EnergyExchangeConditionUI';
	import { is_sunrise_sunset_condition_ui } from 'src/types/SunriseSunsetConditionUI';
	import { is_time_based_cond } from 'src/types/TimeBasedConditionsUI';
	import { is_weather_cond_ui } from 'src/types/WeatherConditionUI';
	import {
		WHEN_WIZARD_STEPS_INDEXES,
		defaultSceneData,
		getTranslationType,
		hasManualExecutionCondition,
	} from '../helpers/when-wizard-helpers';
	import { deepCopy } from 'src/helpers/utilities';
	import { is_math_condition_ui } from 'src/types/Scenes/MathConditionUI';
	import { isExperimentalEnabled, hasEnergyExchangeAccess } from 'src/helpers/user_settings_helpers';
	import { is_manual_execution_condition } from 'src/types/ScenesConditionsTypes';
	import type { ISceneObj } from 'src/types/SceneType';

	export let rawSceneObject: ISceneObj;
	export let sceneData;

	// let selectedCondition = sceneData.selectedCondition;

	// TODO refactor this
	const select_card_condition_options = () => {
		let options: any = [
			{
				selected: false,
				id: 1,
				title: 'device_based_condition',
				name: $format('device_based_condition'),
				premium: false,
				variant: 'radio',
				icon: 'fal fa-microchip-ai',
			},
			{
				selected: false,
				id: 2,
				title: 'time_based_condition',
				name: $format('time_based_condition'),
				premium: false,
				variant: 'radio',
				icon: 'fal fa-calendar-lines-pen',
			},
			// {
			// 	selected: false,
			// 	id: 5,
			// 	title: 'when_automation_runs_condition',
			// 	name: $format('when_automation_runs_condition'),
			// 	premium: false,
			// 	variant: 'radio',
			// 	icon: 'fas fa-film'
			// }
			{
				selected: false,
				id: 5,
				title: 'scene_based_condition',
				name: $format('scene_based_condition', { default: 'Scene based' }),
				premium: false,
				variant: 'radio',
				icon: 'fal fa-film',
			},
			{
				selected: false,
				id: 7,
				title: 'alarm_based_condition',
				name: $format('alarm_based_condition', { default: 'Alarm based' }),
				premium: false,
				variant: 'radio',
				icon: 'fal fa-siren-on',
			},
			{
				selected: false,
				id: 8,
				title: 'math_based_condition',
				name: $format('math_based_condition', {
					default: 'Math expression',
				}),
				premium: false,
				variant: 'radio',
				icon: 'fal fa-square-root-variable',
				hidden: !isExperimentalEnabled('mis'),
				badge: $format('label_experimental', { default: 'experimental' }),
				type: 'experimental',
				badgeIcon: 'fas fa-flask',
			},
			{
				selected: false,
				id: 9,
				title: 'scene_manual_condition',
				name: $format('scenes_title_manual_execution', {
					default: 'Manual execution',
				}),
				premium: false,
				variant: 'radio',
				icon: 'fal fa-play-circle',
				disabled: hasManualExecutionCondition(rawSceneObject),
			},
		];

		options.push(
			{
				selected: false,
				id: 3,
				title: 'weather_forecast_based',
				name: $format('weather_forecast_based'),
				premium: true,
				variant: 'radio',
				icon: 'fal fa-cloud-sun-rain',
				badge: $format('label_premium', { default: 'Premium' }),
				type: 'premium',
				badgeIcon: 'fas fa-gem',
				disabled: !$user_data.premium || !$user_settings?.weather_station?.data?.stationName,
			},
			{
				selected: false,
				id: 4,
				title: 'sunrise_sunset_based_condition',
				name: $format('sunrise_sunset_based_condition'),
				premium: true,
				variant: 'radio',
				icon: 'fal fa-eclipse',
				badge: $format('label_premium', { default: 'Premium' }),
				type: 'premium',
				badgeIcon: 'fas fa-gem',
				disabled: !$user_data.premium || !$user_settings?.weather_station?.data?.stationName,
			},
		);

		const business_features = $user_settings.business_features || [];

		if (hasEnergyExchangeAccess(get(user_data).email, business_features)) {
			options.push({
				selected: false,
				id: 6,
				title: 'energy_exchange',
				name: $format('energy_exchange'),
				variant: 'radio',
				icon: 'fal fa-arrow-trend-up',
				badge: $format('label_business', { default: 'Business' }),
				badgeIcon: 'fas fa-gem',
				type: 'premium',
			});
		}
		return options;
	};

	let selectCards = select_card_condition_options();

	const onSelectCard = (array: ListType, i: number, multipleSelect = false) => {
		return array.map((sc) => {
			if (sc.id === i) {
				return {
					...sc,
					selected: multipleSelect ? !sc.selected : true,
				};
			}
			return {
				...sc,
				selected: multipleSelect ? sc.selected : false,
			};
		});
	};

	const validateCondtitionSelect = (condition) => {
		const { isValid, conditionType } = getTranslationType(condition, sceneData);

		// Reset scene data if no translation
		if (sceneData.selectedCondition !== condition && condition !== conditionType) {
			sceneData = deepCopy({
				...sceneData,
				...defaultSceneData,
			});
		}
		sceneData.isValid = isValid;
		sceneData.validStepIndex = WHEN_WIZARD_STEPS_INDEXES.CONDITION_STEP;
	};

	/** Find the selectedItem id (always start from 1,
	 * because of 0 gotes to undefined and too
	 * much checks if we want to start with 0)
	 **/

	if (sceneData.translated && sceneData.validStepIndex === 0) {
		sceneData.isValid = true;
	}

	// console.warn('WhenWizard: translated', sceneData.translated);

	if (is_device_trigger_ui(sceneData.translated) || is_device_cond_ui(sceneData.translated)) {
		sceneData.selectedCondition =
			selectCards.find((el) => el.title === 'device_based_condition')?.id || undefined;
	} else if (is_time_based_cond(sceneData.translated)) {
		sceneData.selectedCondition =
			selectCards.find((el) => el.title === 'time_based_condition')?.id || undefined;
	} else if (
		is_automation_condition_ui(sceneData.translated) &&
		$alarms[sceneData.translated.scene_id]
	) {
		sceneData.selectedCondition =
			selectCards.find((el) => el.title === 'alarm_based_condition')?.id || undefined;
	} else if (is_automation_condition_ui(sceneData.translated)) {
		sceneData.selectedCondition =
			selectCards.find((el) => el.title === 'scene_based_condition')?.id || undefined;
	} else if (is_sunrise_sunset_condition_ui(sceneData.translated)) {
		sceneData.selectedCondition =
			selectCards.find((el) => el.title === 'sunrise_sunset_based_condition')?.id || undefined;
	} else if (is_weather_cond_ui(sceneData.translated)) {
		sceneData.selectedCondition =
			selectCards.find((el) => el.title === 'weather_forecast_based')?.id || undefined;
	} else if (is_math_condition_ui(sceneData.translated)) {
		sceneData.selectedCondition =
			selectCards.find((el) => el.title === 'math_based_condition')?.id || undefined;
	} else if (is_energy_exchange_ui(sceneData.translated)) {
		sceneData.selectedCondition =
			selectCards.find((el) => el.title === 'energy_exchange')?.id || undefined;
	} else if (is_manual_execution_condition(sceneData.translated)) {
		sceneData.selectedCondition =
			selectCards.find((el) => el.title === 'scene_manual_condition')?.id || undefined;
	} else {
		// console.log('[ConditionStep] sceneData.translated', sceneData.translated);
		// selectedItem = undefined;
		//if add condition set by default selected option DeviceBased
		sceneData.selectedCondition = 1;
	}

	if (typeof sceneData.selectedCondition !== 'undefined') {
		selectCards = onSelectCard(selectCards, sceneData.selectedCondition);
	}

	// Filters which Conditions are shown in the select list
	// - Filters out the 'hidden' options if not enabled
	// - Shows the 'hidden' options if already selected (e.g. Editing)
	//
	// NOTE: Possible to be reused for other "hidden" options in future
	const conditionOptionsFilter = (cardOption) => {
		if (cardOption.selected && cardOption?.hidden) {
			cardOption.hidden = false;
			return true;
		}
		return cardOption?.hidden !== true;
	};

	$: filteredSelectCards = selectCards.filter(conditionOptionsFilter);
</script>

<SelectList
	class="mb-s"
	title={$format(`scene_select_condition`, {
		default: 'Select condition',
	})}
	list={filteredSelectCards}
	variant="radio"
	withSearch={false}
	on:click={(e) => {
		validateCondtitionSelect(e.detail.id);
		sceneData.selectedCondition = e.detail.id;
		selectCards = onSelectCard(selectCards, e.detail.id);
	}}
/>
